/**
 * Centralized admin detection helper.
 * Keep in sync with backend/core/permissions.py ADMIN_EMAILS.
 * SECURITY (Audit Register SEC-1): explicit whitelist ONLY — never grant admin
 * by domain suffix (anyone can register a fake @adwup.ai email).
 */
const ADMIN_EMAILS = new Set([
  "sandrasb91@gmail.com",
  "broker@adwup.ai",
  "admin@adwup.ai",
  "demo@adwup.ai",
]);

export function isAdminEmail(email) {
  if (!email) return false;
  return ADMIN_EMAILS.has(email);
}
